import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import RoutePricingGrid from '../../components/RoutePricingGrid';
import MerchandiseCategoryManager from '../../components/MerchandiseCategoryManager';

const FinancePricingPage = () => {
  const { token } = useAuth();

  return (
    <div className="space-y-6">
      <RoutePricingGrid token={token} />
      <MerchandiseCategoryManager token={token} />
    </div>
  );
};

export default FinancePricingPage;
